// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ReactModal from "react-modal";
import * as AuthConfig$PorterinFeature from "../../../login/domain/config/AuthConfig.mjs";
import * as AuthContextV1$PorterinFeature from "../../../login/view-model/contexts/auth-context/AuthContextV1.mjs";
import * as PnmModalModuleScss from "../styles/PnmModal.module.scss";
import * as AuthWrapperCmp$PorterinFeature from "../../../login/view/components/AuthWrapperCmp.mjs";
import * as PnmBookingFlowLazyCmp$PorterinFeature from "./PnmBookingFlowLazyCmp.mjs";

var styles = PnmModalModuleScss;

function PnmBookingFlowModalCmp(Props) {
  var modal_state = Props.modal_state;
  var close_modal = Props.close_modal;
  var sr_external_id = Props.sr_external_id;
  var mobile = Props.mobile;
  var match = AuthContextV1$PorterinFeature.useAuthContext(undefined);
  var user = match.user;
  var initialLoginFormInput = {
    mobile: mobile
  };
  if (match.is_authenticated) {
    if (user !== undefined) {
      return React.createElement(ReactModal, {
                  isOpen: modal_state,
                  onRequestClose: close_modal,
                  closeTimeoutMS: AuthConfig$PorterinFeature.modal_close_timeout,
                  overlayClassName: styles.overlay,
                  className: "" + styles["modal-container"] + "",
                  ariaHideApp: false,
                  shouldCloseOnOverlayClick: true,
                  children: null
                }, React.createElement(PnmBookingFlowLazyCmp$PorterinFeature.make, {
                      sr_external_id: sr_external_id,
                      user: user,
                      hide_pnm_booking_flow: close_modal
                    }), null);
    } else {
      return null;
    }
  } else {
    return React.createElement(ReactModal, {
                isOpen: modal_state,
                onRequestClose: close_modal,
                closeTimeoutMS: AuthConfig$PorterinFeature.modal_close_timeout,
                overlayClassName: styles.overlay,
                className: "" + styles["modal-container"] + "",
                ariaHideApp: false,
                shouldCloseOnOverlayClick: true,
                children: React.createElement(AuthWrapperCmp$PorterinFeature.make, {
                      close_modal: close_modal,
                      auth_state: /* LoginScreen */{
                        _0: initialLoginFormInput,
                        _1: true
                      },
                      show_close_icon: false,
                      prefill: undefined,
                      is_change_number_cta_visiable: false,
                      close_on_success: false
                    })
              });
  }
}

var make = PnmBookingFlowModalCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
